import React from 'react'

import { Icon, Menu, MenuItem } from 'common/components'

interface Props {
  translate: (key: string) => string
  editDisabled: boolean
  startProposalDisabled: boolean
  uploadEmployeeCensusDisabled: boolean
  onEdit: () => void
  onStartProposal: () => void
  onUploadEmployeeCensus: () => void
}

const Actions: React.FC<Props> = ({
  translate,
  editDisabled,
  startProposalDisabled,
  uploadEmployeeCensusDisabled,
  onEdit,
  onStartProposal,
  onUploadEmployeeCensus,
}) => {
  return (
    <Menu>
      <MenuItem onClick={onEdit} className="mb-0" disabled={editDisabled}>
        <div>
          <Icon type="far fa-pencil" fontAwesome className="mr-8" />
          <span>{translate('prospects-table.edit')}</span>
        </div>
      </MenuItem>
      <MenuItem onClick={onStartProposal} disabled={startProposalDisabled}>
        <div>
          <Icon type="far fa-file-edit" fontAwesome className="mr-8" />
          <span>{translate('prospects-table.start-proposal')}</span>
        </div>
      </MenuItem>
      <MenuItem onClick={onUploadEmployeeCensus} disabled={uploadEmployeeCensusDisabled}>
        <div>
          <Icon type="far fa-user-edit" fontAwesome className="mr-8" />
          <span>{translate('prospects-table.upload-employee-census')}</span>
        </div>
      </MenuItem>
    </Menu>
  )
}

export default Actions
